/* CANI campaign: one full-screen photo per scroll, counter, dots and header colour. */
(() => {
  const init = (camp) => {
    if (camp.dataset.dsReady) return;
    camp.dataset.dsReady = '1';
    const slides = Array.from(camp.querySelectorAll('[data-ds-slide]'));
    if (!slides.length) return;
    const counter = camp.querySelector('[data-ds-counter]');
    const current = camp.querySelector('[data-ds-current]');
    const dotList = camp.querySelector('[data-ds-dots]');
    const dots = Array.from(camp.querySelectorAll('[data-ds-dot]'));
    const header = document.querySelector('[data-ds-header]');
    const overlayHeader = !!header && header.classList.contains('ds-hdr--overlay');
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const snapOn = camp.dataset.snap === 'true' && !reduce && !(window.Shopify && window.Shopify.designMode);
    let onCamp = null;

    if (snapOn) document.documentElement.classList.add('ds-snap');

    const setActive = (slide) => {
      slides.forEach((s) => s.classList.toggle('is-active', s === slide));
      const i = slides.indexOf(slide) + 1;
      if (current) current.textContent = String(i).padStart(2, '0');
      dots.forEach((d) => {
        if (Number(d.dataset.dsDot) === i) d.setAttribute('aria-current', 'true');
        else d.removeAttribute('aria-current');
      });
      camp.style.setProperty('--ds-counter-fg', slide.dataset.fg === 'light' ? '#fff' : '#000');
      if (overlayHeader && onCamp !== false) header.classList.toggle('ds-hdr--light', slide.dataset.fg === 'light');
      slides.forEach((s) => {
        const v = s.querySelector('video');
        if (!v) return;
        if (s === slide) v.play().catch(() => {});
        else v.pause();
      });
    };

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting && e.intersectionRatio >= 0.55) setActive(e.target);
        });
      },
      { threshold: [0.55] }
    );
    slides.forEach((s) => io.observe(s));

    /* Counter, dots and the see-through header only while the campaign is under the header. */
    let ticking = false;
    const checkCamp = () => {
      ticking = false;
      const hh = header ? header.offsetHeight : 0;
      const on = camp.getBoundingClientRect().bottom > hh + 1;
      if (on === onCamp) return;
      onCamp = on;
      if (counter) counter.hidden = !on;
      if (dotList) dotList.hidden = !on;
      if (!overlayHeader) return;
      if (!on) {
        header.classList.remove('ds-hdr--light');
        header.classList.add('ds-hdr--solid');
      } else {
        header.classList.remove('ds-hdr--solid');
        const active = camp.querySelector('.ds-camp__slide.is-active');
        if (active) setActive(active);
      }
    };
    window.addEventListener(
      'scroll',
      () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(checkCamp);
      },
      { passive: true }
    );

    const go = (to) => slides[to].scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    const fills = () => {
      const r = camp.getBoundingClientRect();
      return r.top <= 2 && r.bottom >= window.innerHeight - 2;
    };
    const activeIndex = () => slides.indexOf(camp.querySelector('.ds-camp__slide.is-active') || slides[0]);

    dots.forEach((d) => d.addEventListener('click', () => go(Number(d.dataset.dsDot) - 1)));

    /* Keyboard: Page/arrow keys move one slide while the campaign fills the screen. */
    document.addEventListener('keydown', (e) => {
      if (!snapOn || !fills()) return;
      if (e.target.closest && e.target.closest('input, textarea, select, button, a, [contenteditable]') && e.key === ' ') return;
      if (e.target.closest && e.target.closest('input, textarea, select, [contenteditable]')) return;
      const i = activeIndex();
      let to = null;
      if (e.key === 'ArrowDown' || e.key === 'PageDown' || (e.key === ' ' && !e.shiftKey)) to = i + 1;
      if (e.key === 'ArrowUp' || e.key === 'PageUp' || (e.key === ' ' && e.shiftKey)) to = i - 1;
      if (to === null || to < 0 || to >= slides.length) return;
      e.preventDefault();
      go(to);
    });

    /* Wheel and trackpad: one slide per gesture (native snapping alone can bounce back on short wheel ticks). */
    let locked = false;
    let lockStart = 0;
    let idle = null;
    let acc = 0;
    const release = () => {
      clearTimeout(idle);
      idle = setTimeout(() => {
        if (performance.now() - lockStart > 650) {
          locked = false;
          acc = 0;
        } else release();
      }, 180);
    };
    window.addEventListener(
      'wheel',
      (e) => {
        if (!snapOn || e.ctrlKey || !fills()) return;
        const dir = Math.sign(e.deltaY);
        if (!dir) return;
        const to = activeIndex() + dir;
        if (to < 0) return;
        if (to >= slides.length && !locked) return; /* leave the campaign downwards */
        e.preventDefault();
        if (locked) {
          release();
          return;
        }
        acc += e.deltaY;
        if (Math.abs(acc) < 24) return;
        locked = true;
        lockStart = performance.now();
        acc = 0;
        if (to < slides.length) go(to);
        release();
      },
      { passive: false }
    );

    setActive(slides[0]);
    checkCamp();
  };

  const run = () => document.querySelectorAll('[data-ds-camp]').forEach(init);
  run();
  document.addEventListener('shopify:section:load', run);
  document.addEventListener('shopify:block:select', (e) => {
    const s = e.target.closest && e.target.closest('[data-ds-slide]');
    if (s) s.scrollIntoView({ block: 'start' });
  });
})();
